import { render, staticRenderFns } from "./ManagerCourse.vue?vue&type=template&id=5640b5cb&scoped=true&"
import script from "./ManagerCourse.vue?vue&type=script&lang=js&"
export * from "./ManagerCourse.vue?vue&type=script&lang=js&"
import style0 from "./ManagerCourse.vue?vue&type=style&index=0&id=5640b5cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640b5cb",
  null
  
)

export default component.exports